import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWebsiteLink = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 9,
			cy: 9,
			r: 8,
			stroke: "#999999",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0",
			"mask-type": "alpha",
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 18,
			height: 18,
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 9,
				cy: 9,
				r: 9,
				fill: "#666666"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M0 3V3C4.97056 7.97056 13.0294 7.97056 18 3V3",
					stroke: "#999999",
					strokeWidth: 2
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M0 15V15C4.97056 10.0294 13.0294 10.0294 18 15V15",
					stroke: "#999999",
					strokeWidth: 2
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9 0V0C13.9706 4.97056 13.9706 13.0294 9 18V18",
					stroke: "#999999",
					strokeWidth: 2
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9 18V18C4.02944 13.0294 4.02944 4.97056 9 0V0",
					stroke: "#999999",
					strokeWidth: 2
				})
			]
		})
	]
});
export default SvgWebsiteLink;
